export default function recentlyViewedTracking() {
  const path = window.location.pathname;

  const trackedSegments = [
    'forms',
    'forms-by-organization',
    'forms-by-country',
    'forms-by-location',
    'guidelines',
    'guidelines-by-state',
    'guidelines-by-organization',
    'bulletins',
    'bulletins-by-state',
    'multi-state-bulletins.html',
    'national-bulletins.html',
    'bulletins-by-country',
    'state-supplements-by-state',
    'standard-exceptions',
    'standard-exceptions/alta-exceptions-manual.html',
    'real-estate-practices'
  ];

  // Split the path into segments
  const segments = path.split('/').filter(Boolean); // removes empty strings

  // Check if the first segment might be a language code (2-letter code like "en", "es", etc.)
  const isLangCode = /^[a-z]{2}$/i.test(segments[0]);

  // Reconstruct the relative path without the language segment if it exists
  const relativePath = isLangCode
    ? segments.slice(1).join('/')
    : segments.join('/');

  // Check if the path matches any tracked segments
  const isTrackedPath = trackedSegments.some(segment =>
    relativePath.startsWith(segment)
  );

  if (!isTrackedPath) return;

  const viewedItem = {
    url: window.location.href,
    path: path,
    viewedAt: Date.now(),
    title: document.title
  };

  const storageKey = 'recentlyViewed';
  let recentlyViewed = [];

  try {
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      recentlyViewed = JSON.parse(stored);
    }

    // Remove any existing item with the same path
    recentlyViewed = recentlyViewed.filter(item => item.path !== path);

    // Add the new item at the top
    recentlyViewed.unshift(viewedItem);

    // Limit to 20 most recent
    recentlyViewed = recentlyViewed.slice(0, 20);

    // Save back to localStorage
    localStorage.setItem(storageKey, JSON.stringify(recentlyViewed));
  } catch (err) {
    console.error('Error updating recentlyViewed:', err);
  }
}
